import { Route } from 'react-router-dom';
import { withAuthenticationRequired } from '@auth0/auth0-react';

const ProtectedRoute: any = ({ component, ...args }: any) => (
  <Route component={withAuthenticationRequired(component)} {...args} />
);

export default ProtectedRoute;
